import dataFilter from './dataFilter'

import { get } from 'lodash'

const getId = (item) => {
  return get(item, 'id', item)
}

export default {
  /**
   * @param {[type]} state
   * @param {[type]} agendas
   */
  setAgendas (state, agendas) {
    state.agendas = agendas
  },

  setLoading (state, value) {
    state.loading = value
  },

  /**
   * @param {[type]} state
   * @param {[type]} pagination
   */
  setPagination (state, pagination) {
    state.pagination = pagination
  },

  /**
   * filters
   */

  /**
   * @param {[type]} state
   * @param {[type]} filters
   */
  setFilters (state, filters) {
    state.filters = dataFilter(filters)
  },

  /**
   * @param {[type]} state
   * @param {[type]} specialityId
   */
  setFilterSpecialityId (state, specialityId) {
    state.filters.speciality_id = getId(specialityId)
  },

  /**
   * @param {[type]} state
   * @param {[type]} professionalId
   */
  setFilterProfessionalId (state, professionalId) {
    state.filters.professional_id = getId(professionalId)
  },

  /**
   * @param {[type]} state
   * @param {[type]} patient
   */
  setFilterPatient (state, patient) {
    state.filters.patient = patient
  },

  /**
   * @param {[type]} state
   * @param {[type]} covenantId
   */
  setFilterCovenantId (state, covenantId) {
    state.filters.covenant_id = getId(covenantId)
  },

  /**
   * @param {[type]} state
   * @param {[type]} age
   */
  setFilterAge (state, age) {
    state.filters.age = {
      start: null,
      end: null,
      ...age}
  },

  /**
   * @param {[type]} state
   * @param {[type]} location
   */
  setFilterLocation (state, location) {
    state.filters.location = {
      id: null,
      distance: null,
      price: {
        start: null,
        end: null
      },
      ...location}
  },

  /**
   * @param {[type]} state
   * @param {[type]} price
   */
  setFilterPrice (state, price) {
    state.filters.location.price = {
      start: null,
      end: null,
      ...price}
  },

  setFilterPage (state, page) {
    state.filters.page = page
  },

  /**
   * @param {[type]} state
   * @param {[type]} available
   */
  setFilterAvailable (state, available) {
    state.filters.available = available
  },

  addValueSearchedBy (state, value) {
    state.searchedBy.push(value)
  },

  setValueSearchedBy (state, value) {
    state.searchedBy = []
    state.searchedBy.push(value)
  },

  setValuesSearchedBy (state, values) {
    state.searchedBy = Array.isArray(values) ? values : [values]
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/mutations.js